import { render, staticRenderFns } from "./_BringOwnCapacity.vue?vue&type=template&id=2ed1c9c2"
import script from "./_BringOwnCapacity.vue?vue&type=script&lang=ts"
export * from "./_BringOwnCapacity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports